import React, { FC } from 'react'
import { CommonMarkdownLatexComponent } from '@/components/ui/common/lessons'

interface Props {
  btnTitle: string
  handleClick: () => void
  btnClassName?: string
  isDisabled?: boolean
}

export const AiAssistantPromptsBtn: FC<Props> = ({
  btnTitle,
  handleClick,
  btnClassName = 'px-3 text-white text-sm text-center font-semibold border border-v8-blue rounded-full bg-v8-blue hover:bg-white hover:text-v8-blue transition ease-in-out duration-500 disabled:cursor-not-allowed disabled:opacity-70',
  isDisabled,
}) => {
  return (
    <button
      disabled={isDisabled}
      onClick={handleClick}
      className={btnClassName}
    >
      <CommonMarkdownLatexComponent text={btnTitle} />
    </button>
  )
}
